import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Constants } from '../constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseHttpService } from './basehttp.service';
import { IDispute } from '../models/dispute/dispute.model';
import { IDisputeConfig } from '../models/dispute/disputeConfig.model';

@Injectable({
    providedIn: 'root'
})

export class DisputeService {
    constant: Constants = new Constants();


    constructor(private http: BaseHttpService) { }



    saveDispute(dispute: IDispute): Observable<IDispute> {
        let subject = new Subject<IDispute>();
        this.http.post(this.constant.saveDisputeData, dispute).subscribe((result: IDispute) => {
            subject.next(result);
        });
        return subject.asObservable();
    }

    getDispute(disputeId: number): Observable<IDispute> {
        let subject = new Subject<IDispute>();
        this.http.getById(this.constant.getDisputeData, disputeId.toString()).subscribe((result: IDispute) => {
            subject.next(result);
        });
        return subject.asObservable();
    }

    /**
     * Get all disputes raised against a given survey response id.
     * Used to derive the latest dispute (first entry) for resolution downloads.
     * Returns the underlying HTTP observable so it completes (required for forkJoin).
     */
    getAllDisputesByResponseId(surveyResponseId: number): Observable<IDispute[]> {
        return this.http.getById(this.constant.getAllDisputesByResponseId, surveyResponseId.toString()).pipe(
            map((result: IDispute[]) => result || []),
            catchError(() => of([] as IDispute[]))
        );
    }

    getSurveyDisputeConfig(surveyId: string, incidentId?: number): Observable<IDisputeConfig> {
        let subject = new Subject<IDisputeConfig>();
        let url = this.constant.getSurveyDisputeConfig + '/' + surveyId;
        if (incidentId != null && incidentId > 0) {
            url = url + '/' + incidentId;
        }
        this.http.get(url).subscribe((result: IDisputeConfig) => {
            subject.next(result);
        });
        return subject.asObservable();
    }

     /** Can raise dispute only when           
           * OR if the allowed count is null (unlimited disputes) 
           * OR if the allowed count is more than the raised dispute count 
           * OR if both allowed count and end date are null (unlimited disputes and no end date)
           * OR if end date is null or end date is greater than or equal to today
           * Also, can raise dispute only if there is no open dispute already
          */
    canRaiseDisputeForIncident(surveyDisputeConfig: IDisputeConfig, entryDisputes: IDispute[]): boolean {
        let canRaise = false;
        if (surveyDisputeConfig
            && ((surveyDisputeConfig.maxAllowedDisputes == null)
                || (surveyDisputeConfig.maxAllowedDisputes != null && entryDisputes.length < surveyDisputeConfig.maxAllowedDisputes))
            && ((surveyDisputeConfig.disputeEndDate == null)
                || (surveyDisputeConfig.disputeEndDate != null && new Date(surveyDisputeConfig.disputeEndDate) >= new Date()))) {
            canRaise = true;
        }
        return canRaise;
    }

    isActiveDispute(surveyDisputeConfig:IDisputeConfig):boolean{
        return ((surveyDisputeConfig==null || surveyDisputeConfig.disputeEndDate == null)
                || (surveyDisputeConfig.disputeEndDate != null && new Date(surveyDisputeConfig.disputeEndDate) >= new Date()))
    }


}